import { z } from 'zod';
export const TranscribeTranscriptItemTypeSchema = z.enum(['pronunciation', 'punctuation']);
export const TranscribeTranscriptItemTypeEnum = TranscribeTranscriptItemTypeSchema.enum;
export const TranscribeTranscriptPronunciationItemSchema = z.object({
    id: z.number(),
    type: z.literal(TranscribeTranscriptItemTypeEnum.pronunciation),
    alternatives: z.array(z.object({
        confidence: z.string(),
        content: z.string(),
    })),
    start_time: z.string(),
    end_time: z.string(),
});
export const TranscribeTranscriptPunctuationItemSchema = z.object({
    id: z.number(),
    type: z.literal(TranscribeTranscriptItemTypeEnum.punctuation),
    alternatives: z.array(z.object({ confidence: z.string(), content: z.string() })),
});
export const TranscribeTranscriptAudioSegmentSchema = z.object({
    id: z.number(),
    transcript: z.string(),
    start_time: z.string(),
    end_time: z.string(),
    items: z.array(z.number()),
});
export const TranscribeTranscriptSchema = z.object({
    results: z.object({
        transcripts: z.array(z.object({ transcript: z.string() })),
        items: z.array(z.union([
            TranscribeTranscriptPronunciationItemSchema,
            TranscribeTranscriptPunctuationItemSchema,
        ])),
        audio_segments: z.array(TranscribeTranscriptAudioSegmentSchema),
    }),
});
